import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LazyImage } from "../ui/Elements";
import styled from "styled-components";
import { Arabic, English, Whatsapp } from "../ui/AllImages";
import Cookies from "js-cookie";

const ChangeButton = () => {
  const WhatsApp = () => {
        const phoneNumber = '+966505531205';
        const message = 'Hello, this is Al Asas';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
  const { i18n } = useTranslation();
  const [isEnglishSelected, setIsEnglishSelected] = useState(
    Cookies.get("lang") === "en" ? false : true
  );

  const changeLanguageAndDirection = (lng, dir) => {
    i18n.changeLanguage(lng);
    //document.documentElement.dir = dir;
    document.body.classList.toggle("rtl", dir === "rtl");
    Cookies.set("lang", lng);
    Cookies.set("dir", dir);
  };
  const handleLanguageChange = (lng, dir) => {
    changeLanguageAndDirection(lng, dir);
    setIsEnglishSelected(!isEnglishSelected);
    Cookies.set("lang", lng, { expires: 60, path: "/" });
    Cookies.set("dir", dir, { expires: 60, path: "/" });
  };

  useEffect(() => {
    const savedLang = Cookies.get("lang");
    const savedDir = Cookies.get("dir");
    if (savedLang) {
      i18n.changeLanguage(savedLang);
    }
    else {
      // Set default language to Arabic if not saved in cookies
      i18n.changeLanguage("ar");
      Cookies.set("lang", "ar", { expires: 60, path: "/" });
    }
    if (savedDir) {
      //document.documentElement.dir = savedDir;
      document.body.classList.toggle("rtl", savedDir === "rtl");
    }
    else {
      // Set default direction to RTL if not saved in cookies
      //document.documentElement.dir = "rtl";
      document.body.classList.toggle("rtl", true);
      Cookies.set("dir", "rtl", { expires: 60, path: "/" });
    }
  }, []);

  return (
    <>
      <ButtonBox className="floatBtns">
        <span className="whatsapp" onClick={WhatsApp}>
          <LazyImage src={Whatsapp} />
        </span>
        {isEnglishSelected ? (
          <span
            className="change-Btn"
            onClick={() => handleLanguageChange("en", "ltr")}
          >
            ENG
            {/* <LazyImage src={English} className="english_icon" alt="USA"/> */}
          </span>
        ) : (
          <span
            className="change-Btn"
            onClick={() => handleLanguageChange("ar", "rtl")}
          >
            العربية
            {/* <LazyImage src={Arabic} className="arabic_icon"  alt="Arabic"/> */}
          </span>
        )}
      </ButtonBox>
    </>
  );
};
const ButtonBox = styled.div`

  padding: 0 20px;
  cursor: pointer;
  z-index: 1;
  .whatsapp {
    position: fixed;
    bottom: 15px;
    left: 15px;
    z-index: 50;
    border-radius: 50%;
    box-shadow: 0px 0px 20px 5px rgba(0,0,0,0.25);
    -webkit-box-shadow: 0px 0px 20px 5px rgba(0,0,0,0.25);
    -moz-box-shadow: 0px 0px 20px 5px rgba(0,0,0,0.25);
  }
  .change-Btn {
    position: fixed;
    bottom: 15px;
    right: 15px;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    font-family: var(--arMedium);
    color: var(--white);
    font-size: 18px;
    padding-bottom: 3px;
    background-color: var(--themeColor);
    box-shadow: 0px 0px 20px 5px rgba(0,0,0,0.25);
    -webkit-box-shadow: 0px 0px 20px 5px rgba(0,0,0,0.25);
    -moz-box-shadow: 0px 0px 20px 5px rgba(0,0,0,0.25);
    body.rtl &{
      font-family: var(--familyRbt);
      font-weight: var(--semiBold);
      font-size: 16px;
      padding-top: 4px;
      
    }
  }
  .english_icon {
    // width: 50px;
    // height: 50px;
    border-radius: 50%;
    // margin: 30px 15px;
    cursor: pointer;
    z-index: 1;
  }
  .arabic_icon {
    // width: 70px;
    // height: 70px;
    border-radius: 50%;
    // margin: 20px 15px;
    cursor: pointer;
    z-index: 1;
  }
`;

export default ChangeButton;
